import maplibregl from 'maplibre-gl';
import "./style.scss";

import "maplibre-gl/dist/maplibre-gl.css"

const key="XrQsj7upLPDwvXiflP14"


// {"lng":15.610783169541236,"lat":48.40934295478499}

const map = new maplibregl.Map({
    container: 'map',
    style: `https://api.maptiler.com/maps/dataviz/style.json?key=${key}`,
    center: [15.61078, 48.40934],
    zoom: 13,
    bearing: 0,
    pitch: 20
});
window.map = map
map.addControl(new maplibregl.NavigationControl());
map.on("load",()=>{


let posts = []

function renderData() {
    const featuresEl = document.getElementById("features")
    posts.forEach(post => {
        const section = document.createElement("section")
        section.id = "map-post-" + post.id
        const h3 = document.createElement("h3")
        h3.innerText = post.title.rendered
        const p1 = document.createElement("p")
        p1.innerHTML = post.excerpt.rendered
        const p2 = document.createElement("p")
        const a = document.createElement("a")
        a.href = post.link
        a.target = "readmore"
        a.innerText = "Mehr lesen …"
        p2.appendChild(a)
        section.appendChild(h3)
        section.appendChild(p1)
        section.appendChild(p2)
        if (post.fimg_url) {
            const img = document.createElement("img")
            img.src = post.fimg_url
            section.appendChild(img)
        }
        featuresEl.appendChild(section)
    })
    // const markerLayer = map.addLayer({
    //     id: 'markers',
    //     type: 'symbol',
    //     source: ""
    // });


    posts.forEach(post => {
        const marker = new maplibregl.Marker()
            .setLngLat({lon: post.custom_fields.longitude, lat: post.custom_fields.latitude})
            .addTo(map);
        marker._element.addEventListener("click", () => {
            const currentID = "map-post-" + post.id;
            const sidebarEl = document.getElementById(currentID)
            console.log(sidebarEl)
            sidebarEl.scrollIntoView({behavior: "smooth", block: 'nearest', inline: 'start'});
            sidebarEl.setAttribute('class', 'active');
            if (activeID && activeID !== currentID) {
                document.getElementById(activeID).setAttribute('class', '');
            }
            activeID = currentID

        })
    })
    bindClickListeners()
}

function reqListener() {
    posts = JSON.parse(this.responseText)
    renderData()
}

const oReq = new XMLHttpRequest();
oReq.addEventListener("load", reqListener);
oReq.open("GET", "https://raumforscherinnen.at/wp-json/wp/v2/posts?categories=5");
oReq.send();

// setTimeout(renderData, 500)

function bindClickListeners() {
    const features = [].slice.call(document.querySelectorAll("#features section"));
    features.forEach(element => {
        element.addEventListener("click", () => {
            const id = element.id;
            setActiveChapter(id);
        });
    });
}


let activeID = undefined;

function setActiveChapter(clickedID) {
    if (clickedID === activeID) return;

    const postID = parseInt(clickedID.replace('map-post-', ''), 10);
    const clickedObject = posts.find(post => post.id === postID)
    map.flyTo({
        center: {lon: clickedObject.custom_fields.longitude, lat: clickedObject.custom_fields.latitude},
        zoom: 18,
        bearing: 0 //north up
    });

    document.getElementById(clickedID).setAttribute('class', 'active');
    if (activeID) {
        document.getElementById(activeID).setAttribute('class', '');
    }

    activeID = clickedID;
}
})
